import Battery from 'components/batteries/Battery';
import { mappedItemTypes } from 'services/items';
import Load from '../load/Load';
import Renewable from '../renewables/Renewable';
import Hedge from '../hedges/Hedge';
import AutoformContainer from '../autoform/AutoformContainer';

const PortfolioItem = ({ item, onNodeRename, onNodeOwnershipPercentageUpdate, onNodeItemDelete, refreshMapLayer }) => {
    switch (item.properties.typeId) {
        case mappedItemTypes.LOAD.id:
            return (
                <Load
                    loadItem={item}
                    onNodeRename={onNodeRename}
                    onNodeOwnershipPercentageUpdate={onNodeOwnershipPercentageUpdate}
                    onNodeItemDelete={onNodeItemDelete}
                    refreshMapLayer={refreshMapLayer}
                />
            );

        case mappedItemTypes.BATTERY_STORAGE.id:
            return (
                <Battery
                    batteryItem={item}
                    onNodeRename={onNodeRename}
                    onNodeOwnershipPercentageUpdate={onNodeOwnershipPercentageUpdate}
                    onNodeItemDelete={onNodeItemDelete}
                    refreshMapLayer={refreshMapLayer}
                />
            );

        case mappedItemTypes.SOLAR_ASSET.id: {
            return process.env.REACT_APP_SHOW_EXPERIMENTAL_FEATURES === 'true' ? (
                <Renewable
                    renewableItem={item}
                    onNodeRename={onNodeRename}
                    onNodeOwnershipPercentageUpdate={onNodeOwnershipPercentageUpdate}
                    onNodeItemDelete={onNodeItemDelete}
                    refreshMapLayer={refreshMapLayer}
                />
            ) : null;
        }

        case mappedItemTypes.WIND_ASSET.id:
            return (
                <Renewable
                    renewableItem={item}
                    onNodeRename={onNodeRename}
                    onNodeOwnershipPercentageUpdate={onNodeOwnershipPercentageUpdate}
                    onNodeItemDelete={onNodeItemDelete}
                    refreshMapLayer={refreshMapLayer}
                />
            );

        case mappedItemTypes.FINANCIAL_INSTRUMENT.id:
        case mappedItemTypes.PHYSICAL_INSTRUMENT.id:
            return (
                <Hedge
                    hedgeItem={item}
                    onNodeRename={onNodeRename}
                    onNodeOwnershipPercentageUpdate={onNodeOwnershipPercentageUpdate}
                    onNodeItemDelete={onNodeItemDelete}
                    refreshMapLayer={refreshMapLayer}
                />
            );

        default:
            if (item.properties?.isAutoform) {
                return process.env.REACT_APP_SHOW_EXPERIMENTAL_FEATURES === 'true' ? (
                    <AutoformContainer
                        portfolioItem={item}
                        autoformId={item.properties.typeId}
                        itemId={item.properties.id}
                        onNodeRename={onNodeRename}
                        onNodeItemDelete={onNodeItemDelete}
                        onNodeOwnershipPercentageUpdate={onNodeOwnershipPercentageUpdate}
                    />
                ) : null;
            } else {
                return null;
            }
    }
};

export default PortfolioItem;
